import Head from 'next/head'
import Link from 'next/link'
import { type MouseEvent } from 'react'
import Header from '../src/local/Header'
import ErrorBoundary from '../src/local/ErrorBoundary'
import s from '../styles/RedesignOnkormanyzat.module.css'

const CheckSvg = () => <svg viewBox="0 0 12 12" fill="none" stroke="#27AE78" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="2 6.5 5 9.5 10 3" /></svg>
const CheckSvg13 = () => <svg viewBox="0 0 13 13" fill="none" stroke="#27AE78" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="2 6.5 5.5 10 11 3" /></svg>

const modules = [
  { name: 'Hírek', tagline: 'Azonnali értesítés push üzenettel', desc: 'Fontos közlemények, határozatok és aktualitások azonnali eljuttatása a lakókhoz. Push értesítőn keresztül senki nem marad le semmiről.', tags: ['Címsor','Ismertető','Leírás','Képek','Videók','Térkép','Telefon','E-mail','Weblink'], icon: 'push' },
  { name: 'Információk', tagline: 'Struktúrált, ritkán változó adatok', desc: 'Intézmények, szervezetek, vállalkozások adatlapjai áttekinthető, strukturált formában. Nyitvatartással, elérhetőségekkel, térképpel.', tags: ['Címsor','Ismertető','Képek','Videók','Nyitvatartás','Térkép','Telefon','E-mail','Weblink'], icon: 'info' },
  { name: 'Események', tagline: 'Programok időpont alapján', desc: 'Rendezvények, közgyűlések, helyi programok megjelenítése időrendben. A lakók értesítést kapnak a közelgő eseményekről.', tags: ['Időpontok','Címsor','Ismertető','Képek','Videók','Térkép','Telefon','E-mail'], icon: 'cal' },
  { name: 'Bejelentések', tagline: 'Lakóktól az önkormányzat felé', desc: 'Testre szabható bejelentési lehetőség, amelyen keresztül a lakók jelzéseket küldhetnek. Az önkormányzat jóváhagyja, és válaszolhat képpel vagy szöveggel.', tags: ['Leírás','Képek','Válasz kép','Térkép','Telefon','E-mail','Facebook login','Google login'], icon: 'chat' },
]

const walkModule = { name: 'Falu / Városi séta', tagline: 'Interaktív útvonal GPS helymeghatározással', desc: 'Az önkormányzat felviheti a település sétaútvonalait a nevezetességekkel, emlékhelyekkel, természeti értékekkel. A lakók és turisták az appban valós időben látják saját helyzetüket a térképen, és követhetik az útvonalat megállóról megállóra.', tags: ['GPS helymeghatározás','Interaktív térkép','Útvonal rajz','Megállók / pontok','Képek','Leírás','Hanganyag','Weblink','Távolság jelzés'] }

const whyCards = [
  { title: 'Kedvező ár', desc: 'Töredéke egy egyedi alkalmazás fejlesztési költségének. Havidíjas modell, rejtett díjak nélkül.' },
  { title: 'Folyamatos fejlesztés', desc: 'A platform folyamatosan bővül visszajelzések alapján. Minden frissítés automatikusan elérhető.' },
  { title: 'Könnyű kezelés', desc: 'Webes adminisztrációs felület, amelyen bárki közzétehet tartalmat – informatikai tudás nélkül is.' },
]

const included = [
  { title: 'Android applikáció', desc: 'A Google Play Áruházban elérhető, ingyenesen letölthető alkalmazás.' },
  { title: 'iOS applikáció', desc: 'Az App Store-ban elérhető, iPhone és iPad kompatibilis alkalmazás.' },
  { title: 'Webes megjelenítés', desc: 'Böngészőből is elérhető felület azok számára, akik nem töltik le az appot.' },
  { title: 'Admin felület', desc: 'Könnyen kezelhető webes felület a tartalmak, hírek és események kezeléséhez.' },
  { title: 'Folyamatos fejlesztés', desc: 'Rendszeres frissítések, új funkciók és hibajavítások a visszajelzések alapján.' },
]

const serverSpecs = [
  'Redundáns elektromos hálózat és backup',
  'Professzionális klimatizáció',
  'DDoS elleni védelem',
  'Nagy sávszélességű internet elérés',
  'Maximális rendelkezésre állás (SLA)',
]

const priceFeatures = [
  'Android és iOS applikáció',
  'Webes megjelenítés',
  'Admin felület tartalomkezeléshez',
  'Szerver infrastruktúra és üzemeltetés',
  'Folyamatos fejlesztés és hibajavítás',
]

function ModuleIcon({ type }: { type: string }) {
  const p = { viewBox: "0 0 24 24", fill: "none", stroke: "#27AE78", strokeWidth: 2, strokeLinecap: "round" as const, strokeLinejoin: "round" as const }
  switch (type) {
    case 'push': return <svg {...p}><path d="M18 8h1a4 4 0 010 8h-1" /><path d="M2 8h16v9a4 4 0 01-4 4H6a4 4 0 01-4-4V8z" /><line x1="6" y1="1" x2="6" y2="4" /><line x1="10" y1="1" x2="10" y2="4" /><line x1="14" y1="1" x2="14" y2="4" /></svg>
    case 'info': return <svg {...p}><circle cx="12" cy="12" r="10" /><line x1="12" y1="8" x2="12" y2="12" /><line x1="12" y1="16" x2="12.01" y2="16" /></svg>
    case 'cal': return <svg {...p}><rect x="3" y="4" width="18" height="18" rx="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
    case 'chat': return <svg {...p}><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /></svg>
    case 'pin': return <svg {...p}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
    default: return null
  }
}

function handleEmailClick(event: MouseEvent<HTMLAnchorElement>) {
  event.preventDefault()
  const email = `${String.fromCharCode(105, 110, 102, 111)}@${String.fromCharCode(104, 111, 108, 109, 105, 97, 112, 112)}.${String.fromCharCode(104, 117)}`
  window.location.href = `mailto:${email}`
}

export default function Onkormanyzat() {
  const currentYear = new Date().getFullYear()

  return (
    <ErrorBoundary>
      <div className={s.site}>
        <Head><title>HolmiApp – Önkormányzatoknak</title></Head>
        <Header />

        {/* HERO (dark navy) */}
        <section className={s.pageHero}>
          <div>
            <div className={s.eyebrowDark}><span className={s.eyebrowDot} />Önkormányzatoknak</div>
            <h1 className={s.heroTitle}>Modern kapcsolat a <em>közösséggel</em></h1>
            <p className={s.heroSub}>Csatlakozzon a HolmiApp platformhoz, és nyisson közvetlen csatornát a lakók felé – push üzenetekkel, hírek és események közzétételével, mindössze minimális havidíjért.</p>
            <div className={s.heroCta}>
              <Link href="/Regisztracio" className={s.btnHero}>Regisztráció</Link>
              <a href="#modulok" className={s.btnHeroOutline}>Modulok megtekintése</a>
            </div>
          </div>
          <div className={s.heroCard}>
            <div className={s.priceLabel}>Havi díj</div>
            <div className={s.priceValue}>Kedvező <span>áron</span></div>
            <div className={s.priceSub}>Több milliós fejlesztési költség helyett</div>
            <ul className={s.priceFeatures}>
              {priceFeatures.map(f => (
                <li key={f}><div className={s.checkIcon}><CheckSvg /></div>{f}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* MODULES */}
        <section className={s.modulesSection} id="modulok">
          <div className={s.sectionLabel}>Elérhető funkciók</div>
          <h2 className={s.sectionTitle}>5 modul, minden igényre</h2>
          <p className={s.sectionSub}>2020 decemberétől elérhető moduljaink segítségével az önkormányzat teljes körűen kommunikálhat a lakókkal.</p>
          <div className={s.modulesGrid}>
            {modules.map(m => (
              <div key={m.name} className={s.moduleCard}>
                <div className={s.moduleHeader}><div className={s.moduleIcon}><ModuleIcon type={m.icon} /></div><div><div className={s.moduleName}>{m.name}</div><div className={s.moduleTagline}>{m.tagline}</div></div></div>
                <p className={s.moduleDesc}>{m.desc}</p>
                <div className={s.moduleElementsLabel}>Megjeleníthető elemek</div>
                <div className={s.moduleTags}>{m.tags.map(t => <span key={t} className={s.moduleTag}>{t}</span>)}</div>
              </div>
            ))}
            {/* Full-width walk module */}
            <div className={`${s.moduleCard} ${s.moduleCardFull}`}>
              <div className={s.moduleHeader}><div className={s.moduleIcon}><ModuleIcon type="pin" /></div><div><div className={s.moduleName}>{walkModule.name}</div><div className={s.moduleTagline}>{walkModule.tagline}</div></div></div>
              <p className={s.moduleDesc}>{walkModule.desc}</p>
              <div className={s.moduleElementsLabel}>Megjeleníthető elemek</div>
              <div className={s.moduleTags}>{walkModule.tags.map(t => <span key={t} className={s.moduleTag}>{t}</span>)}</div>
            </div>
          </div>
        </section>

        {/* FACEBOOK INTEGRATION */}
        <section className={s.fbSection}>
          <div className={s.sectionLabel}>Közösségi média</div>
          <h2 className={s.sectionTitle}>Facebook-integráció</h2>
          <p className={s.sectionSub}>Az applikációban közzétett tartalmak automatikusan megjelenhetnek a település Facebook-oldalán is – így egyszerre éri el azokat, akik az appot használják, és azokat is, akik a közösségi médiát követik.</p>
          <div className={s.fbGrid}>
            <div className={s.fbCards}>
              <div className={s.fbCard}>
                <div className={s.fbIconBlue}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="white"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
                </div>
                <div><div className={s.fbCardTitle}>Automatikus közzététel</div><div className={s.fbCardDesc}>Az appban feltöltött hírek és közlemények egy gombnyomással – vagy automatikusan – megjelennek a Facebook-oldalon is.</div></div>
              </div>
              <div className={s.fbCard}>
                <div className={s.fbIconGreen}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#27AE78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" /><circle cx="9" cy="7" r="4" /><path d="M23 21v-2a4 4 0 00-3-3.87" /><path d="M16 3.13a4 4 0 010 7.75" /></svg>
                </div>
                <div><div className={s.fbCardTitle}>Szélesebb közönség</div><div className={s.fbCardDesc}>Egyszerre éri el az app felhasználóit és a Facebook-követőket – nem kell kétszer felvinni ugyanazt a tartalmat.</div></div>
              </div>
              <div className={s.fbCard}>
                <div className={s.fbIconGreen}>
                  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#27AE78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /></svg>
                </div>
                <div><div className={s.fbCardTitle}>Ellenőrzött tartalom</div><div className={s.fbCardDesc}>Az önkormányzat dönti el, mi kerül ki és mikor. A publikálás mindig jóváhagyás után történik.</div></div>
              </div>
            </div>
            <div className={s.fbDark}>
              <div className={s.fbDarkLabel}>Hogyan működik</div>
              <div className={s.fbStep}><div className={s.fbStepNum}>1</div><div className={s.fbStepText}>Az önkormányzat feltölt egy hírt vagy közleményt a HolmiApp admin felületén</div></div>
              <div className={s.fbStep}><div className={s.fbStepNum}>2</div><div className={s.fbStepText}>A tartalom megjelenik az applikációban és push értesítő megy a feliratkozott lakóknak</div></div>
              <div className={s.fbStep}><div className={`${s.fbStepNum} ${s.fbStepNumBlue}`}>3</div><div className={s.fbStepText}>Ugyanaz a bejegyzés automatikusan megjelenik a település Facebook-oldalán is</div></div>
              <div className={s.fbResult}><span className={s.fbResultAccent}>Eredmény:</span> Egy feltöltéssel eléri az app felhasználóit és a Facebook-követőket is – dupla elérés, fele annyi munka.</div>
            </div>
          </div>
        </section>

        {/* WHY */}
        <section className={s.section}>
          <div className={s.sectionLabel}>Miért válasszon minket?</div>
          <h2 className={s.sectionTitle}>Egyszerű, megfizethető, hatékony</h2>
          <p className={s.sectionSub}>Több milliós egyedi fejlesztés helyett kész, bevált platform – minimális havidíjért, folyamatos fejlesztéssel.</p>
          <div className={s.whyGrid}>
            {whyCards.map(c => (
              <div key={c.title} className={s.whyCard}>
                <div className={s.whyIcon}>
                  {c.title === 'Kedvező ár' && <svg viewBox="0 0 24 24" fill="none" stroke="#27AE78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6" /></svg>}
                  {c.title === 'Folyamatos fejlesztés' && <svg viewBox="0 0 24 24" fill="none" stroke="#27AE78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" /></svg>}
                  {c.title === 'Könnyű kezelés' && <svg viewBox="0 0 24 24" fill="none" stroke="#27AE78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" /><line x1="8" y1="21" x2="16" y2="21" /><line x1="12" y1="17" x2="12" y2="21" /></svg>}
                </div>
                <div className={s.whyTitle}>{c.title}</div>
                <div className={s.whyDesc}>{c.desc}</div>
              </div>
            ))}
          </div>
        </section>

        {/* INCLUDED */}
        <section className={s.includedSection}>
          <div className={s.sectionLabel}>Ami benne van</div>
          <h2 className={s.sectionTitle}>Teljes körű szolgáltatáscsomag</h2>
          <p className={s.sectionSub}>Minden, ami az önkormányzati kommunikációhoz kell – egy helyen, egy havidíjban.</p>
          <div className={s.includedGrid}>
            <div className={s.includedList}>
              {included.map(item => (
                <div key={item.title} className={s.includedItem}>
                  <div className={s.includedCheck}><CheckSvg13 /></div>
                  <div><div className={s.includedTitle}>{item.title}</div><div className={s.includedDesc}>{item.desc}</div></div>
                </div>
              ))}
            </div>
            <div className={s.serverCard}>
              <div className={s.serverCardTitle}>Szerver infrastruktúra</div>
              <div className={s.serverCardSub}>Szervereink professzionális szerver hotelban üzemelnek, ahol ipari szabványoknak megfelelő rendelkezésre állást biztosítanak.</div>
              <div className={s.serverSpecs}>
                {serverSpecs.map(spec => (
                  <div key={spec} className={s.serverSpec}><div className={s.serverSpecDot} /><div className={s.serverSpecText}>{spec}</div></div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* VIDEOS */}
        <section className={s.section}>
          <div className={s.sectionLabel}>Referenciák</div>
          <h2 className={s.sectionTitle}>Így használják mások</h2>
          <p className={s.sectionSub}>Tekintse meg, hogyan nyilatkoznak az applikációról az azt már használó önkormányzatok.</p>
          <div className={s.videoGrid}>
            <div className={s.videoCard}><div className={s.videoThumb}><iframe src="https://www.youtube.com/embed/UL7nWng_m2M" title="Üllő" allowFullScreen loading="lazy" /></div><div className={s.videoInfo}><span className={s.videoBadge}>Üllő</span><div className={s.videoTitle}>Az alpolgármester tájékoztatója az applikációról</div></div></div>
            <div className={s.videoCard}><div className={s.videoThumb}><iframe src="https://www.youtube.com/embed/b4lB72LGXYo" title="Maglód" allowFullScreen loading="lazy" /></div><div className={s.videoInfo}><span className={s.videoBadge}>Maglód</span><div className={s.videoTitle}>WTV Híradó – HolmiApp bemutató Maglódon</div></div></div>
          </div>
        </section>

        {/* CONTACT */}
        <section className={s.contactSection} id="contact">
          <div className={s.eyebrowDark}><span className={s.eyebrowDot} />Kapcsolat</div>
          <h2 className={s.contactTitle}>Érdekli a csatlakozás?</h2>
          <p className={s.contactSub}>Írjon nekünk és felvesszük a kapcsolatot. Szívesen bemutatjuk a platformot és megbeszéljük a részleteket.</p>
          <Link href="/Regisztracio" className={s.ctaBtn}>Regisztráljon most</Link>
          <br /><br />
          <a className={s.contactEmail} href="#" onClick={handleEmailClick}>
            <svg viewBox="0 0 24 24" fill="none" stroke="#6EEAB5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,13 2,6" /></svg>
            info <span className={s.emailAt}>kukac</span> holmiapp <span className={s.emailDot}>pont</span> hu
          </a>
        </section>

        {/* FOOTER */}
        <footer className={s.footer}>
          <span className={s.footerLogo}>HolmiApp</span>
          <div className={s.footerLinks}><Link href="/Bemutato">Bemutató</Link><Link href="/Telepulesek">Települések</Link><Link href="/Onkormanyzat">Önkormányzat</Link><Link href="/Galeria">Galéria</Link></div>
          <span className={s.footerCopy}>© {currentYear} HolmiApp. Minden jog fenntartva.</span>
        </footer>
      </div>
    </ErrorBoundary>
  )
}
